// extracted by mini-css-extract-plugin
export default {"quality-score":"quality-score_WKcmN","title":"title_KsbnQ","score":"score_ZEnCu"};